<!--
 * @Author: your name
 * @Date: 2021-04-13 16:16:57
 * @LastEditTime: 2021-04-16 09:53:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ecmp5-client-web/src/views/user/receipt/ReceiptRecord.vue
-->
<template>
  <Nav-bar :has_back="true" :has_right="false" title="开票记录"></Nav-bar>
  <div class="top-margin"></div>
  <div class="container">
    <van-pull-refresh v-model="state.loading" @refresh="onRefresh">
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        @load="initData"
        finished-text="没有更多了"
      >
        <div
          class="item-v"
          @click="toDetails(item.id)"
          v-for="item in state.InvoiceRecordList"
          :key="item"
        >
          <div class="display_flex">
            <span class="t-f14-c99">{{ item.service_provider.name }}</span>
            <img :src="item.serverIcon"  class="s-i">
          </div>
          <div class="m-t-15">
            <div class="display_flex">
              <span class="t-f14-c1a">充电费用</span
              ><span class="t-f14-cf19321 m-l-5">¥{{ item.total_amount }}</span>
            </div>
            <span class="t-f14-c66 m-t-5">{{  $filters.timeFormate(item.updated_at) }}</span>
          </div>
          <img :src="item.statusIcon" class="status-icon" />
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { useRouter } from "vue-router";
import { reactive } from "vue";
import request from "@/api/request";
import httpHelper from "@/helpers/http_helper";
import { useStore } from "vuex";
let router;
let pageCount = 1; //数据页数
let storeContext;
let state = reactive({
  InvoiceRecordList: [],
  finished: false,
  loading: false,
});
let paramsId
export default {
  components: {
    NavBar,
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
  },
  setup() {
    state = reactive({
      InvoiceRecordList: [],
      finished: false,
      loading: false,
    });

    router = useRouter();
    paramsId = router.currentRoute.value.params.id;
    storeContext = useStore();
    return { router, toDetails, state };
  },
  // vue  destroy
  unmounted() {
    pageCount = 1;
    window.removeEventListener("popstate", this.goBack, false);
  },
  methods: {
    initData() {  
      let filterData = {};
      filterData["page"] = pageCount;
      httpHelper.showLoading();

      request
        .getInvoiceRecord(paramsId,filterData)
        .then((res) => {
          state.loading = false;
          httpHelper.hideLoading();
          //No more data
          if (res.data.results.length == 0) {
            state.finished = true;
            return;
          }
          // Initialization data
          if (pageCount == 1) {
            state.InvoiceRecordList.length = 0;
            state.finished = false;
          }
          //Marge data
          state.InvoiceRecordList = state.InvoiceRecordList.concat(
            formatList(res.data.results)
          );
          //Number of request  page increase
          pageCount++;
        })
        .catch(() => {
          state.loading = false;
          httpHelper.hideLoading();
        });
    },
    onRefresh() {
      //重置页数
      pageCount = 1;
      this.initData();
    },
    goBack() {
      if (router.options.history.state.back !== "/user/receipt/container") {
        storeContext.commit("setHomeRouter", "home");
        router.replace("/");
      } else {
        router.back(-1);
      }
    },
  },
};

function formatList(data) {
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    element.statusIcon = formatStatusIcon(data[index].status);
     element.serverIcon =  window.location.origin  + data[index].service_provider.logo.small
  }
  return data;
}
function formatStatusIcon(status) {
  let images;
  if (status == "initial") {
    images = require("@/images/invoices_initial.png");
  }
  if (status == "pending") {
    images = require("@/images/invoices_initial.png");
  }
  if (status == "address") {
    images = require("@/images/invoices_done.png");
  }
   if (status == "passed") {
    images = require("@/images/invoices_done.png");
  }
  if (status == "rejected") {
    images = require("@/images/invoices_reject.png");
  }
  return images;
}
function toDetails(id) {
  router.push(`/user/receipt/details/${id}`);
}
</script>
<style scoped>
.s-i{
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-left: 10px;
}
.status-icon {
  width: 44px;
  height: 44px;
  position: absolute;
  right: 15px;
  bottom: 15px;
}
.item-v {
  background: #fff;
  margin-top: 10px;
  padding: 15px;
  position: relative;
}
.company_icon {
  width: 20px;
  height: 20px;
}
</style>